import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Box, Link, Typography } from '@mui/material';

import { Text } from '~/components/ui/text/Text';
import { SOCIAL_ICON_ITEMS } from '~/constants/socials';
import { getSocialMediaReducer } from '~/store/reducers/previewScreens/social-media/selectors';
import { COLORS } from '~/styles/colors';
import { mainPreviewContainerStyles } from '~/styles/common';

type SocialMediaPreviewScreenProps = {
  isMyMicrosite?: boolean;
};
export function SocialMediaPreviewScreen({ isMyMicrosite }: SocialMediaPreviewScreenProps) {
  const {
    micrositeStyles,
    bacgkroundColor,
    fonts: { title, text },
    appInformation: { head, description },
    micrositeData,
  } = useSelector(getSocialMediaReducer);

  const { t } = useTranslation();

  return (
    <Box
      sx={[
        {
          ...mainPreviewContainerStyles,
          alignItems: 'normal',
          background: bacgkroundColor,
          padding: '0 0.5rem',
          ...micrositeStyles.container,
        },
        isMyMicrosite && { margin: 0, minHeight: '100vh', borderRadius: 0 },
      ]}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', mt: 3, textAlign: 'center', minWidth: '100%' }}>
        <Typography
          sx={{
            fontSize: 15,
            mb: '8px',
            fontFamily: title,
            padding: '0 .6rem',
            wordBreak: 'break-word',
            color: COLORS.white,
          }}
        >
          {head}
        </Typography>
        <Typography
          sx={{
            fontSize: 9,
            fontFamily: text,
            mb: 3,
            padding: '0 .6rem',
            wordBreak: 'break-word',
            color: COLORS.white,
          }}
        >
          {description}
        </Typography>

        {!!micrositeData?.socials?.length && (
          <Box
            sx={{
              backgroundColor: COLORS.white,
              borderRadius: '20px',
              color: COLORS.black,
              fontSize: 10,
              padding: '16px',
              mb: 2,
            }}
          >
            <Text
              sx={{
                fontFamily: text,
                marginBottom: '10px',
                mt: 1,
                wordBreak: 'break-word',
                fontSize: '14px',
                fontWeight: 600,
              }}
            >
              {t('titles:socialMediaMicroSiteTitle')}
            </Text>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                gap: '5px',
              }}
            >
              {micrositeData?.socials.map((item) => {
                const socialIcon = SOCIAL_ICON_ITEMS.find(
                  ({ network, label }) =>
                    network?.toLowerCase() === item.network?.toLowerCase() ||
                    label?.toLowerCase() === item.label?.toLowerCase(),
                );

                return (
                  <Link
                    key={item.id}
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '5px',
                      backgroundColor: COLORS.lightGray,
                      gap: '6px',
                      borderRadius: '8px',
                      textDecoration: 'none',
                    }}
                  >
                    <img src={socialIcon?.icon} alt={socialIcon?.label} width={20} height={20} />
                    <Box>
                      <Typography
                        color={COLORS.black08}
                        fontSize={12}
                        sx={{ wordBreak: 'break-word', fontWeight: '600', textAlign: 'left' }}
                      >
                        {socialIcon?.label}
                      </Typography>
                      <Typography
                        color={COLORS.black08}
                        fontSize={9}
                        sx={{ wordBreak: 'break-word', textAlign: 'left' }}
                      >
                        {item.title}
                      </Typography>
                    </Box>
                  </Link>
                );
              })}
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
}
